<template>
  <div
    class="r-block"
    :class="[
      {
        row,
        col,
        radius,
        start,
        center,
        bottom,
        scroll,
        disabled,
        noPadding,
        spaceBetween,
        alignBetween,
        stretch,
        rtl,
        bottomSpace,
        rounded
      },
      borderClass,
      bgClass
    ]"
    :style="style"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    border: {
      type: [Boolean, String],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    radius: {
      type: Boolean,
      default: false
    },
    row: {
      type: Boolean,
      default: false
    },
    rtl: {
      type: Boolean,
      default: false
    },
    col: {
      type: Boolean,
      default: false
    },
    gap: {
      type: Number,
      default: 0.5
    },
    start: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    },
    bottom: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    spaceBetween: {
      type: Boolean,
      default: false
    },
    alignBetween: {
      type: Boolean,
      default: false
    },
    stretch: {
      type: Boolean,
      default: false
    },
    scroll: {
      type: Boolean,
      default: false
    },
    padding: {
      type: Number,
      default: 0.5
    },
    width: {
      type: String,
      default: null
    },
    background: {
      type: String,
      default: null
    },
    bottomSpace: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      return {
        gridGap: `${this.gap}rem`,
        padding: `${this.padding}rem`,
        width: this.width
      }
    },
    borderClass() {
      let className
      switch (typeof this.border) {
        case 'boolean':
          className = this.border === true ? 'border' : ''
          break
        case 'string':
          className = `border-${this.border}`
          break
      }
      return className
    },
    bgClass() {
      if (!this.background) return null
      return `bg-${this.background}`
    }
  }
}
</script>

<style lang="scss" scoped>
.r-block {
  display: grid;
  padding: 0.5rem;
  align-items: center;
  align-content: start;

  &.row {
    grid-auto-flow: row;
  }

  &.scroll {
    height: 100%;
    overflow: auto;
  }

  &.disabled {
    pointer-events: none;
    opacity: 0.4;
  }

  &.start {
    justify-content: start;
  }

  &.center {
    justify-content: center;
  }

  &.bottom {
    align-items: end !important;
  }

  &.col {
    grid-auto-flow: column;
  }

  &.radius {
    border-radius: $border-radius;
  }

  &.spaceBetween {
    justify-content: space-between;
  }

  &.alignBetween {
    align-content: space-between;
  }

  &.stretch {
    grid-template-columns: repeat(auto-fit, minmax(50%, 100%));
  }

  &.noPadding {
    padding: 0 !important;
  }

  &.rtl {
    direction: rtl;
  }

  &.bg {
    &-containers {
      background-color: $bg-containers;
    }
    &-containers-white {
      background-color: $bg-containers-white;
    }
  }

  &.bottomSpace {
    padding-bottom: 1rem !important;
  }

  &.border {
    @include border;

    &-top {
      @include border-top;
    }
    &-bottom {
      @include border-bottom;
    }
    &-right {
      @include border-right;
    }
    &-left {
      @include border-left;
    }
  }

  &.bg {
    &-containers {
      background-color: $bg-containers;
    }
    &-containers-white {
      background-color: $bg-containers-white;
    }
  }

  &.rounded {
    border-radius: $border-radius;
  }
}
</style>
